"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageDialogButtonHandler = exports.EMessageDialogButtonType = void 0;
exports.MessageDialog = MessageDialog;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var message_dialog_1 = require("../../features/thunks/message-dialog");
var hooks_1 = require("../../store/hooks");
var EMessageDialogButtonType;
(function (EMessageDialogButtonType) {
    EMessageDialogButtonType["OK"] = "ok";
    EMessageDialogButtonType["CANCEL"] = "cancel";
})(EMessageDialogButtonType || (exports.EMessageDialogButtonType = EMessageDialogButtonType = {}));
var messageDialogButtonHandler = (_a = {},
    _a[EMessageDialogButtonType.OK] = function () {
        console.log("OK button clicked");
    },
    _a[EMessageDialogButtonType.CANCEL] = function () {
        console.log("Cancel button clicked");
    },
    _a);
exports.messageDialogButtonHandler = messageDialogButtonHandler;
function MessageDialog() {
    var _a = (0, hooks_1.useAppSelector)(function (state) { return state.messageDialog; }), isOpen = _a.isOpen, header = _a.header, body = _a.body, buttons = _a.buttons;
    var dispatch = (0, hooks_1.useAppDispatch)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, disableAnimation: true, onOpenChange: function (isOpen) {
                if (!isOpen) {
                    dispatch((0, message_dialog_1.closeMessageDialogThunk)());
                }
            }, closeButton: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:close-circle-bold", className: "text-danger", fontSize: 26 }) }), children: (0, jsx_runtime_1.jsx)(react_1.ModalContent, { children: function (onClose) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.ModalHeader, { className: "flex flex-col gap-1", children: header !== null && header !== void 0 ? header : "No Header" }), (0, jsx_runtime_1.jsx)(react_1.ModalBody, { children: (0, jsx_runtime_1.jsx)("div", { children: body !== null && body !== void 0 ? body : "No Body" }) }), (0, jsx_runtime_1.jsx)(react_1.ModalFooter, { children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button, index) { return ((0, jsx_runtime_1.jsx)(react_1.Button, { variant: button.variant, onPress: function () {
                                    messageDialogButtonHandler[button.type]();
                                    onClose();
                                }, children: button.label }, index)); }) })] })); } }) }) }));
}
